export default "__VITE_ASSET__lB7F6Q1T__"